import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@abyss/web/ui/Breadcrumbs';
import {
  usePageDataStore,
  BreadcrumbItem,
} from '@src/store/common/PageDataStore';
import { useBreadcrumbStore } from '@src/store/common/BreadcrumbStore';

export const Breadcrumb = () => {
  const [data, setData] = useState<Array<BreadcrumbItem>>([]);
  const pageData = usePageDataStore((state) => state.pageData);
  const breadcrumbs = useBreadcrumbStore((state) => state.breadcrumbs);

  useEffect(() => {
    if (
      pageData &&
      typeof pageData === 'object' &&
      'items' in pageData &&
      Array.isArray((pageData as any).items) &&
      (pageData as any).items.length > 0
    ) {
      setData((pageData as any).items);
    }
  }, [pageData]);

  useEffect(() => {
    if (breadcrumbs?.length > 0) {
      setData(
        breadcrumbs.map((item) => ({
          ...item,
          href: typeof item.href === 'string' ? item.href : '',
        }))
      );
    }
  }, [breadcrumbs]);

  return (
    <React.Fragment>
      <Breadcrumbs
        divider={"/"}
        size={12}
        items={data}
        css={{ 'abyss-breadcrumbs-root': { flexWrap: 'wrap' } }}
      />
    </React.Fragment>
  );
};
